import { DynamicFormProps } from '@ui/interfaces'
import {useAuth} from "@ui/providers/AuthProvider.tsx";

export const SaveAndCancelButtons = ({ cancelClick }: Pick<DynamicFormProps, 'cancelClick'>) => {
  const { isDemoMode } = useAuth()
  return (
    <div className="mt-6 flex items-center gap-x-6">
      {cancelClick && (
        <button type="button" className="text-sm font-semibold leading-6 text-gray-900" onClick={cancelClick}>
          Cancel
        </button>
      )}
      <button
        type="submit"
        className="rounded-md disabled:bg-gray-400 bg-primary-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-primary-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
        disabled={isDemoMode}>
        Save
      </button>
    </div>
  )
}
